import store from './store.js';
import Vue from "vue";
import firebase from 'firebase/app';
import {modsList} from './functions.js';
import {Notification} from 'element-ui';

require('firebase/auth');
require('firebase/firestore');
require('firebase/storage');
require('firebase/functions');
const config = {
  	apiKey: "AIzaSyCMkJ-k0Q1wzac0lAhzhrUhi1gEA6LGLTA",
    authDomain: "elements-239920.firebaseapp.com",
    databaseURL: "https://elements-239920.firebaseio.com",
    projectId: "elements-239920",
    storageBucket: "elements-239920.appspot.com",
    messagingSenderId: "941387713900",
};
firebase.initializeApp(config);

var db = firebase.firestore();
const storage = firebase.storage().ref();

var fFunctions = firebase.functions();
  
firebase.auth().onAuthStateChanged(function(user) {

  // console.log(user);
  /*if (user == null) {
    firebase.auth().signInAnonymously().then(function(){
      // router.push({name: 'profile'});
    });
  };*/

  var isUserChecked = false;
  var newRecipes = [];
  var ratingError = false;
  var sumRating = 0;
  var itemCollection = {};
  var userCollection = [];

  var userOptions = {};
  var hiddenMods = [];
  var passiveMods = [];

  if (user) {
  	store.commit('updateUser',{ user });
    db.collection('users').doc(user.uid).get().then(doc=>{
      if (!doc.exists) {
        // console.log('user doc create');
        db.collection('users').doc(user.uid).set({});
      };          
    });    
    db.collection('users').doc(store.state.user.uid).onSnapshot(function(doc) {
      userOptions = doc.data();
      hiddenMods = [];
      if (userOptions != undefined) {
        hiddenMods = userOptions.hiddenMods || [];
      };
      itemCollection = {};
      var filters = [];
      store.commit('updateUserOptions',{ userOptions });
      var k = modsList.length - hiddenMods.length;
      passiveMods = [];
      if (k > 0) {
        modsList.forEach(el=>{
          if (hiddenMods.indexOf(el.value) == -1) {
            filters.push(el);
            db.collection('mods').doc(el.value).get().then(function(doc){
                itemCollection[doc.id] = [];
                var data = doc.data();
                for (var prop in data) {
                  data[prop].name = prop;
                  data[prop].mod = doc.id;
                  data[prop].displayName = data[prop].displayNameRu;
                  itemCollection[doc.id].push(data[prop]);
                  var key = data[prop].recipe.key;
                  for (var subProp in key) {
                    var mod = key[subProp].mod;
                    if (passiveMods.indexOf(mod) == -1 && hiddenMods.indexOf(mod) != -1) {
                      passiveMods.push(key[subProp].mod);
                    };
                  };
                };
                k--;
              if ( k == 0 ) {
                if (passiveMods.length > 0) {
                  showMods();
                } else {
                  store.commit('updateItemCollection', {itemCollection: itemCollection});
                  store.commit('updateFilters', {filters: filters});
                  if (!isUserChecked) {userCheck(); isUserChecked = true;};
                };
                // db.collectionGroup('recipes').limit(100).get().then(function(querySnapshot){

                /*var itemCollectionFull = [];
                for (var prop in itemCollection) {
                  itemCollectionFull = itemCollectionFull.concat(itemCollection[prop]);
                };*/
                // console.log(itemCollectionFull);

                /*db.collectionGroup('recipes').get().then(function(querySnapshot){ 
                  console.log(querySnapshot.size);
                  querySnapshot.forEach(function(doc) {
                    var data = doc.data();
                    for (var prop in data) {
                      if (prop != 'author' && prop != 'rating' && prop != 'newRecipes') {
                        // var el = data[prop];
                        // var key = el.key;
                        // console.log(prop);
                        // console.log(data[prop]);
                        var key = data[prop].key;
                        // console
                        for (var subProp in key) {
                          // console.log(key[subProp]);
                          // console.log(key[subProp].mod);
                          var meta = itemCollectionFull.find(function(subEl){return subEl.name == key[subProp].item;});
                          if (meta != undefined) {
                            key[subProp].mod = meta.mod;
                          };
                          // console.log(meta.mod);
                        };
                        data[prop].key = key;
                        data[prop].mod = doc.ref.path.split('/')[1];
                      };
                    };
                    console.log(data);
                    doc.ref.update(data).then(function(){console.log('модификация успешно обновлена')});
                  });
                });*/

                /*db.collection('mods').get().then(function(querySnapshot){
                  console.log(querySnapshot.size);
                  querySnapshot.forEach(function(doc){
                    itemCollection[doc.id] = [];
                    var data = doc.data();
                    for (var prop in data) {
                      var key = data[prop].recipe.key;
                      // console.log(key);
                      for (var subProp in key) {
                        var meta = itemCollectionFull.find(function(subEl){return subEl.name == key[subProp].item;});
                        if (meta == undefined) {
                          console.log(data[prop]);
                          // console.log(key[subProp].item);
                        };
                        key[subProp].mod = meta.mod;
                      };
                      data[prop].recipe.key = key;
                      data[prop].mod = doc.id;
                    };
                    console.log(data);
                    doc.ref.update(data).then(function(){console.log('модификация успешно обновлена')});
                  });
                });*/

              };  
            });
          };
        });
      } else {        
        store.commit('updateItemCollection', {itemCollection: {}});
        store.commit('updateFilters', {filters: []});
      };  
    });
    function userCheck(){
      if (user.uid == 'cwPdIDPREeWuZVco6GhF2xGQX6u2') {
        db.collectionGroup('recipes').where("author", "==", 'cwPdIDPREeWuZVco6GhF2xGQX6u2').get().then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            doc.ref.delete();
            // console.log('Удаление предметов тестового профиля');
          });
          setUserCollection();
        });
      } else {
        setUserCollection();
      };
    };
    function setUserCollection(){
      passiveMods = [];
      // console.log('setUserCollection');
      db.collectionGroup('recipes').where("author", "==", user.uid).onSnapshot(function(querySnapshot) {
        userCollection = {};
        querySnapshot.forEach(function(doc) {
          var data = doc.data();
          var mod = doc.ref.path.split('/')[1];
          newRecipes[mod] = data.newRecipes || [];
          userCollection[mod] = [];
          newRecipes[mod] = [];
          for (var prop in data) {
            if (prop != 'author' && prop != 'rating' && prop != 'newRecipes') {  
              var el = data[prop];
              var price = el.priceType == 'customPrice' ? el.customPrice : el.recipePrice;
              var meta = undefined;
              if (itemCollection[mod]) {
                meta = itemCollection[mod].find(function(subEl){return subEl.name == prop;});
              } else {
                // console.log(passiveMods, hiddenMods);
                if (passiveMods.indexOf(mod) == -1 && hiddenMods.indexOf(mod) != -1) {
                  passiveMods.push(mod);
                };
                var key = el.key;
                for (var subProp in key) {
                  var mod = key[subProp].mod;
                  if (passiveMods.indexOf(mod) == -1 && hiddenMods.indexOf(mod) != -1) {
                    passiveMods.push(key[subProp].mod);
                  };
                };
              };
              if (meta != undefined) {
                userCollection[mod].push({
                  displayName: meta.displayName,
                  item: prop,
                  price: price,
                  image: meta.image,
                  ingredients: el.ingredients,
                  id: meta.itemID,
                  pattern: el.pattern,
                  key: el.key,
                  count: el.count,
                  mod: meta.mod,
                  customPrice: el.customPrice,
                  recipePrice: el.recipePrice,
                  priceType: el.priceType,
                }); 
              };
            };  
          };

          if (passiveMods.length > 0) {
            showMods();
          };

          if (data.rating == undefined && !ratingError) {
            var data = {};
            data.rating = 0;
            doc.ref.update(data).then(function(){
            }).catch(function(err){
              ratingError = true;
            });
          } else {
            sumRating += data.rating;
          };
        });
        store.commit('updateUserCollection', {userCollection: userCollection});
        store.commit('updateNewRecipes', {newRecipes: newRecipes});
      });
    };
  }; 

  function showMods(){
    // console.log(passiveMods);
    var message = 'Предметы из модификиций ';
    passiveMods.forEach(el=>{
      hiddenMods.splice(hiddenMods.indexOf(el), 1);
      message += modsList.find(subEl=>{return subEl.value == el}).label + ', ';
    });
    message.slice(-1, 2);
    message += ' могут встречаться в рецептах Ваших предметов, поэтому их отображение было восстановлено';
    var data = {hiddenMods: hiddenMods};
    db.collection('users').doc(store.state.user.uid).update(data).then(function(){
      Notification({title: 'Заметка', message: message, type: 'info'});
      passiveMods = [];
    });
  };

});

function removeItem(mod, item) {
  var self = this;
  var data = {};
  data[item] = firebase.firestore.FieldValue.delete();
  db.collection('mods').doc(mod).collection('recipes').doc(self.$store.state.user.uid).update(data).then(function(){
    self.$notify({title: 'Успех', message: 'Предмет успешно удалён из Вашей коллекции', type: 'success'});
  });
};

function suggestRecipe() {
  var self = this;
  var key = self.recipe.key;
  for (var prop in key) {
    delete key[prop].price;
  };
  var recipe = {
    pattern: self.recipe.pattern,
    key: key,
    count: self.recipe.count,
    author: self.$store.state.user.uid,
    item: self.recipe.item,
    mod: self.recipe.mod,
  };
  // console.log(recipe);
  db.collection("logs").doc("suggest-recipes").update({
    recipes: firebase.firestore.FieldValue.arrayUnion(recipe),
  }).then(function(){
    self.$notify({title: 'Успех', message: 'Спасибо, Ваш рецепт успешно предложен', type: 'success'});
  });
};

firebase.firestore().enablePersistence().catch(function(err) {
  	if (err.code == 'failed-precondition') {
      	// Multiple tabs open, persistence can only be enabled
      	// in one tab at a a time.
      	// ...
  	} else if (err.code == 'unimplemented') {
      	// The current browser does not support all of the
      	// features required to enable persistence
      	// ...
  	};
});

export {db, storage, removeItem, fFunctions, suggestRecipe};